import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { apiPost } from "../../service/admin/apiService";
import { showSuccess, showError } from "../../utils/toast";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const [showModal, setShowModal] = useState(true);
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const tk = localStorage.getItem("tk") || "";
  const userType = localStorage.getItem("ut") || "";

  const validate = () => {
    if (!password || !repassword) {
      showError("Password and Confirm Password cannot be blank.");
      return false;
    }
    if (password !== repassword) {
      showError("Passwords do not match.");
      return false;
    }
    return true;
  };

  const ChangePassword = async () => {
    if (!validate()) return;

    const payload = {
      action: "setpassword",
      to: tk,
      ol: oldPassword,
      nw: password,
    };

    console.log("payload", payload);
    try {
      setLoading(true);
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      console.log("response changepass", response);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
      } else if (response?.responsedetails) {
        console.error("change:", response?.responsedetails);
        showSuccess("Password updated successfully!!!");
        setShowModal(false);
        navigate("/admin");
      }
    } catch (err) {
      console.error("Error:", err);
      showError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (userType == 1) {
      navigate("/admin-dashboard");
    } else if (userType == 2) {
      navigate("/review-data");
    }
    setShowModal(false);
  };

  return (
    <>
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header className="custom-header" closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Old Password</Form.Label>
              <Form.Control
                type="oldPassword"
                placeholder="Enter old password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirm new password"
                value={repassword}
                onChange={(e) => setRepassword(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              ChangePassword();
            }}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Updating...
              </>
            ) : (
              "Update"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChangePassword;
